<div
  layout="row"
  layout-margin
  layout-wrap
>
  <div
    flex="30"
    flex-sm="100"
  >
    <form
      [formGroup]="formSettings"
      (submit)="submitPainelSettingsForm()"
      method="post"
    >
      <div style="margin: 40px">
        <div>
          <h2 class="title">Painel</h2>
          <div class="card">
            <h3 class="setting-title">Chamada</h3>
            <div class="settings-form">
              <div class="form-inputs">
                <mat-form-field>
                  <mat-label>Falar nome do paciente</mat-label>
                  <mat-select
                    required
                    style="height: 10px !important"
                    formControlName="SPEECH_NAME_PANEL"
                  >
                    <mat-option value="true">Sim</mat-option>
                    <mat-option value="false">Não</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field
                  [ngClass]="{
                    disabled: this.formSettings.get('SPEECH_NAME_PANEL')?.value === 'false'
                  }"
                >
                  <mat-label>Falar texto antes do nome</mat-label>
                  <input
                    formControlName="SPEECH_PREV_PANEL"
                    matInput
                  />
                </mat-form-field>
                <mat-form-field
                  [ngClass]="{
                    disabled: this.formSettings.get('SPEECH_NAME_PANEL')?.value === 'false'
                  }"
                >
                  <mat-label>Falar nome do local ou guichê</mat-label>
                  <mat-select
                    required
                    style="height: 10px !important"
                    formControlName="SPEECH_LOCAL_ROOM"
                  >
                    <mat-option value="true">Sim</mat-option>
                    <mat-option value="false">Não</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                [ngClass]="{
                  disabled: this.formSettings.get('SPEECH_NAME_PANEL')?.value === 'false',
                  content: true,
                  'speech-content': true
                }"
              >
                <button
                  type="button"
                  [ngClass]="{
                    'try-btn': true,
                    playing: isAudioPlaying
                  }"
                  mat-raised-button
                  (click)="tryPanelAudio()"
                >
                  <mat-icon class="multitrack_audio">multitrack_audio</mat-icon>
                  Testar
                </button>
                <p
                  class="speech-phrase"
                  *ngIf="
                    this.formSettings.get('SPEECH_NAME_PANEL')?.value === 'true';
                    else showPhrase
                  "
                >
                  <span>"</span>
                  {{ formSettings.get('SPEECH_PREV_PANEL')?.value }} Pedro Silva
                  {{ formSettings.get('SPEECH_LOCAL_ROOM')?.value === 'true' ? ', Guichê 3' : '' }}
                  <span>"</span>
                </p>

                <ng-template #showPhrase>
                  <p class="speech-phrase">
                    A opção "Falar nome do paciente" deve estar habilitada para realizar o teste
                  </p>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="card">
            <h3 class="setting-title">Exibição</h3>
            <div class="settings-form">
              <div class="form-inputs">
                <mat-form-field>
                  <mat-label>Dimensão da senha/anúncio </mat-label>
                  <mat-select
                    (selectionChange)="changeDisplayTestSrc()"
                    required
                    style="height: 10px !important"
                    formControlName="TOTEM_DIMENSAO"
                  >
                    <mat-option value="auto">Expansão automática</mat-option>
                    <mat-option value="fixo">Fixo 50% / 50%</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-label> Histórico de chamados </mat-label>
                  <mat-select
                    (selectionChange)="changeDisplayTestSrc()"
                    required
                    style="height: 10px !important"
                    formControlName="TOTEM_HISTORY"
                  >
                    <mat-option value="true">Sim</mat-option>
                    <mat-option value="false">Não</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <figure class="content display-content">
                <img
                  [src]="displayTestSrc"
                  alt=""
                />
              </figure>
            </div>
          </div>
        </div>

        <div>
          <h2 class="title">Anúncios/Mostrar Fila</h2>
          <div class="card">
            <mat-radio-group
              aria-label="Selecione uma opção"
              formControlName="EXIBITION_TYPE"
              style="gap: 10px; display: flex"
            >
              <mat-radio-button value="1">Anúncios</mat-radio-button>
              <mat-radio-button value="2">Mostrar Fila</mat-radio-button>
            </mat-radio-group>
            <fieldset
              *ngIf="dataAvailable === true && formSettings.value.EXIBITION_TYPE === '1' && formAds"
              [formGroup]="formAds"
              (submit)="submitPainelSettingsForm()"
              method="post"
            >
              <div class="settings-form" style="margin-top: 20px;">
                <div class="form-inputs">
                  <mat-form-field>
                    <mat-label>Descrição</mat-label>
                    <input
                      formControlName="nome"
                      matInput
                    />
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>youtube.com/watch?v=</mat-label>
                    <input
                      formControlName="url"
                      matInput
                    />
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Status</mat-label>
                    <mat-select
                      required
                      style="height: 20px !important"
                      formControlName="status"
                    >
                      <mat-option value="ativo">Ativo</mat-option>
                      <mat-option value="inativo">Inativo</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="content ad-content">
                  <iframe
                    width="1280"
                    height="720"
                    [src]="getSafeUrl('https://www.youtube.com/embed/' + formAds.get('url')?.value)"
                    title="AO VIVO: Acompanhe as principais notícias do dia na Record News"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </fieldset>
            <fieldset
              *ngIf="dataAvailable === true && formSettings.value.EXIBITION_TYPE === '2'"
              [formGroup]="formPatientQueueSettings"
              (submit)="submitPainelSettingsForm()"
              method="post"
              style="margin-top: 15px"
            >
              <h3 style="width: 100%;">
                Exibição da lista dos próximos atendimentos no formato de carrossel das agendas ligadas ao painel.
              </h3>
              <div style="gap: 20px; display:block; width:100%;">
                <div class="form-inputs" style="width: 100%; flex-direction: row;">
                  <div class="form-inputs">
                    <div class="sort">
                      <mat-form-field style="width: 85%;">
                        <mat-label>Ordenação por agendamento</mat-label>
                        <mat-select
                        [(value)]="selectedAppointmentSchedules"
                          multiple
                        >
                          <mat-option
                            *ngFor="let schedule of carouselSortByCheckin"
                            [value]="schedule"
                          >
                            {{ schedule.nome }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <button type="button"
                        (click)="addSchedules('appointment')"
                        class="new-panel-btn add-sort-btn">
                        <mat-icon class="add-sort-icon">add</mat-icon>
                      </button>
                    </div>

                    <div class="chip-container">
                      <span class="chip" *ngFor="let schedule of carouselSortByAppointment">
                        {{ schedule.nome }}
                      </span>
                    </div>
                  </div>

                  <div class="form-inputs">
                    <div class="sort">
                      <mat-form-field style="width: 85%;">
                        <mat-label>Ordenação por checkin</mat-label>
                        <mat-select
                        [(value)]="selectedCheckinSchedules"
                        multiple>

                          <mat-option
                          *ngFor="let schedule of carouselSortByAppointment"
                          [value]="schedule"
                        >
                          {{ schedule.nome }}
                        </mat-option>
                        </mat-select>
                      </mat-form-field>

                      <button type="button"
                        (click)="addSchedules('checkin')"
                        class="new-panel-btn add-sort-btn">
                        <mat-icon class="add-sort-icon">add</mat-icon>
                      </button>
                    </div>

                      <div class="chip-container">
                        <span class="chip" *ngFor="let schedule of carouselSortByCheckin">
                          {{ schedule.nome }}
                        </span>
                      </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div class="card">
          <h3 class="setting-title">Parâmetros</h3>
          <div class="form-inputs-row">
            <mat-form-field style="width: 100%">
              <mat-label> Usar paineis </mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="TOTEM_USEPANELS"
              >
                <mat-option value="true">Sim</mat-option>
                <mat-option value="false">Não</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%">
              <mat-label>Usar local no Painel</mat-label>
              <mat-select
                required
                style="height: 10px !important"
                formControlName="USAR_LOCAL"
              >
                <mat-option value="Sim">Sim</mat-option>
                <mat-option value="Nao">Não</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div
          class="card"
          *ngIf="appearanceEnabled === 'true'"
        >
          <h3 class="setting-title">Aparência</h3>
          <div class="form-inputs-row">
            <mat-form-field style="width: 100%">
              <mat-label>Logomarca</mat-label>
              <button
                type="button"
                mat-icon-button
                matPrefix
                (click)="f_input.click()"
              >
                <mat-icon>attach_file</mat-icon>
              </button>
              <input
                type="text"
                readonly
                matInput
                formControlName="PANEL_LOGO_IMAGE_NAME"
              />
              <input
                type="file"
                hidden
                #f_input
                (change)="handleFileInputChange(f_input.files)"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Fonte</mat-label>
              <input
                type="text"
                matInput
                [matAutocomplete]="auto"
                formControlName="TEXT_FONT_FAMILY"
              />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option
                  *ngFor="let font of filteredFontOptions | async"
                  [value]="font"
                >
                  {{ font }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <div
            class=""
            style="display: inline-flex; width: 100%"
          >
            <mat-form-field style="width: 100%">
              <div style="display: flex; align-items: center">
                <input
                  matInput
                  type="color"
                  class="color-input"
                  style="width: 30px; height: 30px; padding: 0; margin-right: 4px"
                  formControlName="PANEL_CLOCK_BACKGROUND_COLOR"
                  (input)="onColorChange($event, 'PANEL_CLOCK_BACKGROUND_COLOR')"
                />
                <input
                  matInput
                  type="text"
                  style="flex: 1"
                  formControlName="PANEL_CLOCK_BACKGROUND_COLOR"
                  (input)="onColorChange($event, 'PANEL_CLOCK_BACKGROUND_COLOR')"
                />
              </div>
              <mat-label>Cor de fundo relógio</mat-label>
            </mat-form-field>
            <mat-form-field style="margin-left: 30px; width: 100%">
              <div style="display: flex; align-items: center">
                <input
                  matInput
                  type="color"
                  class="color-input"
                  style="width: 30px; height: 30px; padding: 0; margin-right: 4px"
                  formControlName="PANEL_CLOCK_TEXT_COLOR"
                  (input)="onColorChange($event, 'PANEL_CLOCK_TEXT_COLOR')"
                />
                <input
                  matInput
                  type="text"
                  style="flex: 1"
                  formControlName="PANEL_CLOCK_TEXT_COLOR"
                  (input)="onColorChange($event, 'PANEL_CLOCK_TEXT_COLOR')"
                />
              </div>
              <mat-label>Cor do texto relógio</mat-label>
            </mat-form-field>
          </div>
          <div class="form-inputs-row">
            <button
              mat-raised-button
              color="primary"
              type="button"
              style="background-color: #d1d5db; color: #353535"
              (click)="restoreAppearance()"
            >
              Restaurar Aparência
            </button>
          </div>
        </div>

        <div class="col-xs-12 col-sm-8 mx-auto mt-5">
          <div>
            <button
              [disabled]="showSpinner ? true : false"
              class="mt-3"
              type="submit"
              mat-raised-button
              color="primary"
            >
              <mat-spinner
                diameter="18"
                [style.display]="showSpinner ? 'inline-block' : 'none'"
              >
              </mat-spinner
              >Salvar Alterações
            </button>
          </div>
        </div>
      </div>
    </form>

    <app-add-painel></app-add-painel>
  </div>
</div>
